import { apiClient, apiClientPaginated } from '@/lib/api-client';
import type {
  Location,
  CreateLocationPayload,
  UpdateLocationPayload,
} from '@/types/location';

export const locationService = {
  list(params?: { page?: number; limit?: number; search?: string; is_active?: string }) {
    const query = new URLSearchParams();
    if (params?.page) query.set('page', String(params.page));
    if (params?.limit) query.set('limit', String(params.limit));
    if (params?.search) query.set('search', params.search);
    if (params?.is_active) query.set('is_active', params.is_active);
    const qs = query.toString();
    return apiClientPaginated<Location[]>(`/locations${qs ? `?${qs}` : ''}`);
  },

  getById(id: string) {
    return apiClient<Location>(`/locations/${id}`);
  },

  create(payload: CreateLocationPayload) {
    return apiClient<Location>('/locations', { method: 'POST', body: payload });
  },

  update(id: string, payload: UpdateLocationPayload) {
    return apiClient<Location>(`/locations/${id}`, { method: 'PATCH', body: payload });
  },

  remove(id: string) {
    return apiClient<{ message: string }>(`/locations/${id}`, { method: 'DELETE' });
  },
};
